import { render, staticRenderFns } from "./TableRow.vue?vue&type=template&id=3df2ff20"
import script from "./TableRow.vue?vue&type=script&lang=ts"
export * from "./TableRow.vue?vue&type=script&lang=ts"
import style0 from "./TableRow.vue?vue&type=style&index=0&id=3df2ff20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports